// extracted by mini-css-extract-plugin
export default {"nonFullscreen":"U7chR3We"};